export default function onGltfLoaderError(err : Error | unknown): void {
  console.error('GltfLoaderError', err)
}